// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3wseL","footer":"ModalUpdate_footer__1WFp4"};